module.exports = __webpack_public_path__ + "static/media/instagram.ae13bf03.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/instagram.svg
// module id = 1292
// module chunks = 0